import React, { useState, useContext, useEffect } from 'react';
import { useAuth } from '../../provider';
import { useNavigate, useLocation } from "react-router-dom";
import * as api from '../../Auth/auth'
import {AppBar, Toolbar, Box, Drawer, Stack, Tooltip} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { LogoWhite } from '../Logo/Logo';
import { Logo } from '../Logo/Logo';
import SidebarList from './SidebarList';
import LanguageSelector from '../../language';
import NavIcons from './NavIcons';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
//import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { ColorModeContext } from "../../theme";
import IconButton from '@mui/material/IconButton';
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";



// ##################################################


export default function Sidebar(props) {

const theme = useTheme();
const colorMode = useContext(ColorModeContext);

const { handleLogout } = useAuth();

let navigate = useNavigate();
let location = useLocation();
  
    const handleLogoutapi = async () => {
      let response = await api.logout()
      await handleLogout(response);
       GoTo()
  }
  
  let from = location.state?.from?.pathname || "/";
     const GoTo = () => { navigate(from, { replace: true }) }

     const [dialogopen, dialogsetOpen] = useState(false);
     const dialoghandleOpen = () => {dialogsetOpen(true);};
     const dialoghandleClose = () => {dialogsetOpen(false);};

  

  const [open, setOpen] = useState(false);
  // Distinct from `open` — only true while the tour itself is driving the
  // drawer (this event is only ever dispatched by WalkthroughTour). The
  // drawer's own nav list scrolls independently of the page body, so the
  // tour's document-level scroll lock doesn't reach it; this flag lets the
  // list's own overflow be locked too for as long as the tour has it open.
  const [tourControllingSidebar, setTourControllingSidebar] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  useEffect(() => {
    const handler = (e) => {
      setOpen(e.detail.open);
      setTourControllingSidebar(e.detail.open);
      // Reset the drawer's own internal scroll to the top on every tour-driven
      // toggle (open AND close) — a plain DOM query rather than a React ref,
      // since the ref forwarded through PaperProps wasn't reliably landing on
      // the actual scrollable node (Drawer wraps Paper in its own Slide
      // transition). Runs on a rAF so it applies after the Drawer's own open
      // transition has actually mounted/attached the node this frame.
      requestAnimationFrame(() => {
        const paper = document.querySelector('.MuiDrawer-paper');
        if (paper) paper.scrollTop = 0;
      });
    };
    window.addEventListener('tour:sidebar', handler);
    return () => window.removeEventListener('tour:sidebar', handler);
  }, []);

  // Wider on xl only — body1 text jumps to 1.2rem at that breakpoint in the
  // theme's type scale, so the fixed 300px width made labels feel cramped.
  const drawerWidth = { xs: 300, sm: 300, md: 300, lg: 300, xl: 340 }
  

  return (
<>

{/* Appbar - Menu on top */}
<Box sx={{ flexGrow: 1,  }}>
<ChangeColorScroll {...props}>

<AppBar position="fixed" elevation={0}>
<Toolbar sx={{  ml: {xs: 0, sm: 4, md: 4, lg: 8, xl: 8 }, 
                          mr: {xs: 0, sm: 4, md: 4, lg: 4, xl: 12 }, 
                          maxWidth: {xs: '99%', sm: '98%', md: '98%', lg: '98%', xl: '98%'},}}>

  <Box sx={{ flex: 1, pt: '1rem',}} > 
      <Stack direction={{ xs: 'row' }} spacing={{ xs: 0, sm: 2 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems:'center' }}>
           
           {/* Logo*/}
           <Box sx={{pt: '0.3rem'}}> {theme.palette.mode === "light" ? ( <Logo /> ) : (<LogoWhite /> )}</Box>  
           
           {/* Drawer*/}
          <Box data-tour="sidebar-toggle">
            <NavIcons title='Menu' onClick={toggleDrawer(true)} iconselect={ <MenuIcon sx={{fontSize: '100%'}} />} />
          </Box>
           
           {/* Color Mode Toggle Button*/}
          <Box display="flex">
            <Tooltip title="Select Color Mode" placement="bottom">
            <IconButton onClick={colorMode.toggleColorMode} sx={{ p: { xs: 0.5, sm: 1 } }}>
                {theme.palette.mode === "light" ? ( <DarkModeOutlinedIcon sx={{ fontSize: { xs: '1.1rem', sm: '1.5rem' } }} /> ) : (<LightModeOutlinedIcon sx={{ fontSize: { xs: '1.1rem', sm: '1.5rem' } }} /> )}
            </IconButton>
            </Tooltip>
          </Box> 

            {/* Language Toggle Button*/}
          <Box display="flex"> <LanguageSelector /> </Box>

      </Stack>
    </Box> 

    <Box sx={{ pt: '1rem',}}>
        <Stack direction={{ xs: 'row' }} spacing={{ xs: 0, sm: 2 }} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems:'center' }}>
            
            <NavIcons title='CockpitWelcome' onClick={dialoghandleOpen} to="/CockpitWelcome" iconselect={ <DashboardIcon sx={{fontSize: '100%'}} />} />  
            <NavIcons title='Account' onClick={dialoghandleOpen} to="/UserAdminWelcome" iconselect={ <PersonIcon sx={{fontSize: '100%'}} />} />  
            <NavIcons title='Logout' onClick={handleLogoutapi} to="/" iconselect={ <LogoutIcon sx={{fontSize: '100%'}} />} />
        </Stack>
  </Box>


</Toolbar>
</AppBar>

</ChangeColorScroll>
</Box>



{/* Sidebar, Drawer */}

      <Drawer open={open} keepMounted elevation={0} onClose={toggleDrawer(false)}
                sx={{ fontFamily:'Raleway', display: 'block', flexShrink: 0,
                    '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box', }, }}
                    PaperProps={{ sx: {px:1, height: `calc(100% - 0px)`, backgroundColor: 'greydark.C900', borderRadius: '4px',
                            margin: 0, borderColor:  'greydark.C900',
                            overflowY: tourControllingSidebar ? 'hidden' : 'auto',
                            touchAction: tourControllingSidebar ? 'none' : 'auto'} }}
                >

            <Box onClick={toggleDrawer(false)} >
                    
            <Box sx={{px: '1em', pt: '3em' }} > <LogoWhite large/>   </Box>

                    <SidebarList />
            
            </Box>
      </Drawer>

      </>  
  );
}


/* Helper Function header get transparent when scrolling */


function ChangeColorScroll(props) {
  const { children, window } = props;
  const theme = useTheme();
  const dark = theme.palette.mode === 'dark';

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 60,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    sx: {
      backgroundColor: trigger
        ? alpha(theme.palette.background.default, 0.92)
        : 'transparent',
      backdropFilter: trigger ? 'blur(14px)' : 'none',
      WebkitBackdropFilter: trigger ? 'blur(14px)' : 'none',
      boxShadow: trigger
        ? dark ? '0 1px 12px 0 rgba(0,0,0,0.45)' : '0 1px 8px 0 rgba(0,0,0,0.08)'
        : 'none',
      transition: 'background-color 0.25s ease, box-shadow 0.25s ease',
    },
  });
}